/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PolarisOnboardingPageType from '@jira/spa-apps__polaris-onboarding/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyOnboardingPage: LazyComponent<{
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<string, any>): React.JSX.Element;
	displayName: string;
}> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PolarisOnboardingPageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-polaris-onboarding", jiraSpaEntry: "async-polaris-ideas" */ '@jira/spa-apps__polaris-onboarding/src/index.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncOnboardingPage = (): React.JSX.Element => (
	<LazyPage Page={LazyOnboardingPage} pageId="async-polaris-onboarding" shouldShowSpinner={false} />
);

export default AsyncOnboardingPage;
